export const IAnalyticsRepositoryType = Symbol('IAnalyticsRepository');
